import client from '../utils/client';
import { campaignsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const campaignService = {
  campaignsList,
  addCampaign,
  getCampaign,
  updateCampaign
}

function campaignsList(pageID, perPage, searchInput) {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(campaignsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addCampaign(formDate) {
  return client.post(campaignsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getCampaign(campaignID) {
  return client.get(campaignsUrl + '/' + campaignID + '/show?per_page=9999')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateCampaign(formDate) {
  return client.post(campaignsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}